import { component } from 'picoapp';

export default component(async (node) => {
  const input = node.querySelector('input');

  node.addEventListener('submit', async (event) => {
    event.preventDefault();

    await navigator.clipboard.writeText(input.value);
  });
});
